var map = {
	"./archive/config/permissions.ts": [
		"3ee8",
		"chunk-2d0c577b"
	],
	"./audits/config/permissions.ts": [
		"8160",
		"chunk-2d0dd469"
	],
	"./billing/config/permissions.ts": [
		"dc46d",
		"chunk-772f770d"
	],
	"./board/config/permissions.ts": [
		"beec",
		"chunk-2d21b517"
	],
	"./documents/config/permissions.ts": [
		"9ac1",
		"chunk-2d0f026c"
	],
	"./emails/config/permissions.ts": [
		"718a",
		"chunk-2d0d6079"
	],
	"./profile/config/permissions.ts": [
		"9509",
		"chunk-2d0e571b"
	],
	"./tasks/config/permissions.ts": [
		"578c",
		"chunk-2d0c8e43"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8e04";
module.exports = webpackAsyncContext;